/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateBNoticeSubmission} from '../api'

export const useMutationUpdateBNoticeSubmission = createReactQueryMutationHook('updateBNoticeSubmission', updateBNoticeSubmission)
